"use strict";

var sanitizeMongoKeys = require('../utils/sanitizeMongoKeys');

var dataSourceCtrl = [
    "graphDataFactory",
    "$uibModal",
    "$scope",
    "Graph",
    "Form",
    "ReportConfig",
    "Integration",
    "$state",
    "$translate",
    "dialog",
    "$sce",
    "myDepartments",
    "toast",
    function (graphDataFactory, $uibModal, $scope, Graph, Forms, ReportConfig, Integration, $state, $translate, dialog, $sce, myDepartments, toast) {
        var _this = this;
        this.Forms = Forms;
        this.ReportConfig = ReportConfig;
        this.elementsTypeToFilter = [
            "text",
            "select",
            "formula",
            "number",
            "group",
            "multiple",
            "autonumeric"
        ];
        this.datasource = _this.element.templateData.datasource;
        if (this.datasource.viewConfig == undefined) {
            this.datasource.viewConfig = {
                openOptions: true,
                openConfig: false,
                openFields: false,
                openColumns: false,
                openScritpt: false,
                openAll: false,
            };
        }
        if (this.datasource.type != "distinct") {
            this.datasource.elements = this.datasource.elements || {};
            this.datasource.moreFields = this.datasource.moreFields || {};
            if (Array.isArray(this.datasource.elements)) {
                this.datasource.elements = this.datasource.elements.filter((el) => el && (el.name || el.id));
            }
            ["_createdAt", "_startedAt", "closedAt", "validateDate"].forEach((id) => {
                const el = _this.datasource.elements[id];
                if (!el) return;
                if (!el.id) el.id = id;
                if (!el.type) el.type = "timestamp";
            });
        }

        _this.loadingDepartments = false;
        _this.loadingIntegrations = false;
        _this.forms = _this.forms || [];
        _this.integrations = _this.integrations || [];
        _this.lstDataSources = [];
        _this.departmentforms = _this.departmentforms || [];
        _this.isGraphColumn = true;
        _this.formActions = [];

        _this.ACTION_RESPONSE_DEFAULT_FIELDS = [
            { type: "text", name: "Nombre", id: "name" },
            { type: "timestamp", name: "Creado", id: "_createdAt" },
            { type: "text", name: "ID", id: "id" },
            { type: "text", name: "ID de Item", id: "itemId" },
            { type: "text", name: "ID de Acción", id: "actionId" },
        ];

        _this.loadActionFormFields = function () {
            _this.allElementsForm = [].concat(_this.ACTION_RESPONSE_DEFAULT_FIELDS);
            _this.filteredElementsForm = [];
            _this.datasource.elements = _this.datasource.elements || {};

            _this.ACTION_RESPONSE_DEFAULT_FIELDS.forEach(function (def) {
                if (_this.datasource.elements[def.id]) {
                    _this.datasource.elements[def.id].name = def.name;
                }
            });

            Object.keys(_this.datasource.elements).forEach(function (key) {
                if (!_this.allElementsForm.find(function (el) { return el.id === key; })) {
                    delete _this.datasource.elements[key];
                }
            });
        };

        _this.clearActionDatasourceState = function () {
            _this.datasource.elements = {};
            _this.datasource.actionId = undefined;
            _this.datasource.actionIndex = undefined;
            delete _this.datasource.actionName;
            _this.datasource.filters = [];
            _this.datasource.moreFields = {};
            _this.formActions = [];
        };

        _this.normalizeResponseParams = function (responseParams) {
            if (!responseParams) return [];
            if (Array.isArray(responseParams)) {
                return responseParams.map(function (item) {
                    if (typeof item === "string") {
                        return {
                            key: item,
                            label: item,
                            type: "text",
                        };
                    }
                    return {
                        key: item.key || item.id || item.name,
                        label: item.label || item.name || item.key,
                        type: item.type || "text",
                        fx: item.fx,
                    };
                }).filter(function (p) { return p.key; });
            }
            if (typeof responseParams === "object") {
                return Object.keys(responseParams).map(function (key) {
                    let val = responseParams[key];
                    if (typeof val === "string") {
                        return { key: key, label: val, type: "text" };
                    }
                    return {
                        key: key,
                        label: val.label || val.name || key,
                        type: val.type || "text",
                        fx: val.fx,
                    };
                });
            }
            return [];
        };

        _this.clearActionColumns = function () {
            if (!_this.datasource.moreFields) return;
            Object.keys(_this.datasource.moreFields).forEach(function (key) {
                if (_this.datasource.moreFields[key].fromAction) {
                    delete _this.datasource.moreFields[key];
                }
            });
        };

        _this.loadActionResponseParams = function (selectedAction) {
            if (!selectedAction || !selectedAction.actionData || !selectedAction.actionData.connection) {
                _this.clearActionColumns();
                return;
            }

            let params = _this.normalizeResponseParams(
                selectedAction.actionData.connection.responseParams
            );

            if (!params.length) {
                toast.error($translate.instant("DASHBOARD.DASH_BUILDER.DATASOURCE.NO_ACTION_RESPONSE_PARAMS"));
            }
            let paramKeys = params.map(function (p) { return p.key; });

            Object.keys(_this.datasource.moreFields).forEach(function (key) {
                if (_this.datasource.moreFields[key].fromAction && paramKeys.indexOf(key) === -1) {
                    delete _this.datasource.moreFields[key];
                }
            });

            params.forEach(function (param) {
                let colName = param.label || param.key;
                _this.datasource.moreFields[param.key] = {
                    id: param.key,
                    name: colName,
                    fx: param.fx || "row['".concat(colName, "']"),
                    type: param.type || "text",
                    graphColumn: true,
                    fromAction: true,
                    templateData: { align: "left" },
                };
            });
        };

        _this.getFormActions = function () {
            if (!_this.datasource.formId) {
                return Promise.resolve([]);
            }
            return _this.ReportConfig.find({
                filter: {
                    where: {
                        formId: _this.datasource.formId,
                    },
                },
            })
                .$promise.then(function (reportConfigs) {
                    let reportConfig = reportConfigs && reportConfigs[0];
                    if (!reportConfig || !Array.isArray(reportConfig.actions)) {
                        return [];
                    }
                    return reportConfig.actions
                        .map(function (action, index) {
                            return Object.assign({}, action, {
                                index: index,
                                selectId: action.actionId || ("idx_" + index),
                            });
                        })
                        .filter(function (action) {
                            return action.action === "webhook" && action.inactive !== true;
                        });
                })
                .catch(function (e) {
                    console.error("Error loading form actions:", e);
                    return [];
                });
        };

        _this.getSelectedAction = function (actions) {
            actions = actions || _this.formActions || [];
            if (_this.datasource.actionId) {
                let byId = actions.find(function (action) {
                    return action.selectId === _this.datasource.actionId
                        || action.actionId === _this.datasource.actionId;
                });
                if (byId) return byId;
            }
            if (_this.datasource.actionIndex !== undefined
                && _this.datasource.actionIndex !== null
                && _this.datasource.actionIndex !== "") {
                return actions.find(function (action) {
                    return action.index === _this.datasource.actionIndex;
                });
            }
            return null;
        };

        _this.getActionFilterFields = function (selectedAction) {
            selectedAction = selectedAction || _this.getSelectedAction();
            let params = _this.normalizeResponseParams(
                selectedAction && selectedAction.actionData && selectedAction.actionData.connection
                    ? selectedAction.actionData.connection.responseParams
                    : null
            );
            return params.map(function (p) {
                return {
                    id: p.key,
                    name: p.label || p.key,
                    type: p.type || "text",
                };
            });
        };

        _this.pruneActionFilters = function (selectedAction) {
            if (!_this.datasource.filters || !_this.datasource.filters.length) return;
            const validIds = { createdAt: true, _createdAt: true };
            _this.getActionFilterFields(selectedAction).forEach(function (field) {
                if (field.id) validIds[field.id] = true;
            });
            const pruneList = function (list) {
                if (!list) return;
                for (let i = list.length - 1; i >= 0; i--) {
                    const rule = list[i];
                    if (rule.type === "field" && rule.fieldId && !validIds[rule.fieldId]) {
                        list.splice(i, 1);
                    } else if (rule.type === "operator" && rule.rules) {
                        pruneList(rule.rules);
                    }
                }
            };
            _this.datasource.filters.forEach(function (group) {
                pruneList(group.conditions);
            });
        };

        _this.onActionSelected = function () {
            _this.clearActionColumns();
            let selectedAction = _this.getSelectedAction();
            if (selectedAction) {
                _this.datasource.actionName = selectedAction.name;
                _this.datasource.actionIndex = selectedAction.index;
                _this.datasource.actionId = selectedAction.selectId;
                _this.loadActionResponseParams(selectedAction);
                _this.pruneActionFilters(selectedAction);
            } else {
                delete _this.datasource.actionName;
                delete _this.datasource.actionIndex;
                delete _this.datasource.actionId;
                _this.datasource.filters = [];
            }
        };

        _this.onDatasourceTypeChange = function () {
            if (_this.datasource.type === "action") {
                _this.reloadActionElements();
            }
        };

        _this.reloadActionElements = function () {
            _this.clearActionDatasourceState();

            if (!_this.datasource.formId || _this.datasource.formId === "") {
                _this.allElementsForm = [];
                _this.filteredElementsForm = [];
                return;
            }

            _this.getFormActions().then(function (actions) {
                _this.formActions = actions;
                _this.loadActionFormFields();
                if (!actions.length) {
                    toast.error($translate.instant("DASHBOARD.DASH_BUILDER.DATASOURCE.NO_ACTION_WEBHOOKS"));
                }
            });
        };

        // Forms grouped by department for select-optgroup (lista compartida)
        _this.flattenedForms = graphDataFactory.getFlattenedForms();

        this.reloadDepartments = () => graphDataFactory.reloadDepartments();

        this.reloadIntegrations = () => graphDataFactory.reloadIntegrations();

        this.openSelectedIntegration = () => {
            if (!_this.datasource || !_this.datasource.integrationId) {
                return;
            }
            const hashUrl = $state.href('dashboard.integrations.integration', {
                integrationId: _this.datasource.integrationId
            });
            if (!hashUrl) {
                return;
            }
            const url = window.location.origin + window.location.pathname + hashUrl;
            window.open(url, '_blank');
        };

        $scope.$watch(() => graphDataFactory.isLoadingDepartments(), (value) => {
            _this.loadingDepartments = !!value;
        });
        $scope.$watch(() => graphDataFactory.isLoadingIntegrations(), (value) => {
            _this.loadingIntegrations = !!value;
        });
        $scope.$on("graph-catalog-updated", function (event, kind) {
            _this.flattenedForms = graphDataFactory.getFlattenedForms();
            if (kind === "forms" && ["query", "distinct", "action"].includes(_this.datasource.type)) {
                _this.reloadElements();
            }
        });

        this.delColumn = function (id) {
            delete _this.datasource.moreFields[id];
        };

        this.addColumn = function () {
            let fieldId = Math.random().toString(36).substring(2, 9);
            _this.datasource.moreFields[fieldId] = {
                name: "",
                id: fieldId,
                fx: "",
                type: "text",
                graphColumn: true,
                templateData: { align: "left" },
            };
        };

        this.processNodesRecursively = function (nodes, parentPrefix, instanceSuffix = "",level=1) {
            const result = [];
            nodes.forEach((node) => {
                const nodeId = `validate_${node.id}${instanceSuffix}`;
                const nodeName = `Validate_${node.name || node.label}${instanceSuffix}`;
                const processed = {
                    id: nodeId,
                    name: nodeName,
                    type: node.type,
                    parentId: parentPrefix,
                    validate_pages: true,
                    level:level
                };

                result.push(processed);

                if (node.nodes && Array.isArray(node.nodes)) {
                    const children = _this.processNodesRecursively(node.nodes, nodeId, instanceSuffix,level+1);
                    result.push(...children);
                }
            });

            return result;
        }

        this.getElementsForm = function (typeElement, withNodes = false, includeValidatePages = false) {
            function camposValidacion(validate_pages,instanceNumber) {
                const instanceSuffix = instanceNumber!=null ? "_" + instanceNumber : "";
                const instanceTitle = "Validación ".concat(instanceNumber!=null ? instanceNumber : "Final");
                let level=0;
                let newCols = [
                    { level:level,type: "validate", name: instanceTitle, id: "validateTitle".concat(instanceSuffix) },
                    { level:level+1,type: "text", name: "Estado de la Validación".concat(instanceSuffix), id: "validateState".concat(instanceSuffix) },
                    { level:level+1,type: "text", name: "Comentario de la Validación".concat(instanceSuffix), id: "validateComment".concat(instanceSuffix) },
                    { level:level+1,type: "text", name: "Validador".concat(instanceSuffix), id: "validateUser".concat(instanceSuffix) },
                    { level:level+1,type: "timestamp", name: "Fecha de la Validación".concat(instanceSuffix), id: "validateDate".concat(instanceSuffix) },
                ];
                level=level+1;
                if (validate_pages) {
                    newCols = newCols.concat(
                        validate_pages.flatMap((page) => {
                            return page.fields.reduce((lst, ele) => {
                                const new_ele = {
                                    level:level,
                                    name: "Validate_".concat(ele.name || ele.label).concat(instanceSuffix),
                                    id: "validate_".concat(ele.id).concat(instanceSuffix),
                                    type: ele.type, //No se donde rompera si usa el tipo original ele.type  tenia siempre text...no se porque 
                                    validate_pages: true
                                };

                                if (ele.nodes && Array.isArray(ele.nodes))
                                    new_ele.nodes = _this.processNodesRecursively(ele.nodes, new_ele.id, instanceSuffix,level+1);
                                lst.push(new_ele);
                                return lst;
                            }, []);
                        })
                    );
                }
                return newCols;
            }

            if (!_this.datasource.formId) return Promise.resolve([]);
            return graphDataFactory.getFormById(_this.datasource.formId)
                .then(function (formSelected) {

                    if (formSelected == undefined) return;
                    let baseCols = [];
                    if (typeElement == undefined) {
                        baseCols = [
                            { type: "history", name: "Historial de Validaciones", id: "validateHistory" },
                            { type: "number", name: "ID", id: "id" },
                            { type: "checkbox", name: "Bloqueado", id: "locked" },
                            { type: "checkbox", name: "Bloqueado por", id: "lockedBy" },
                            { type: "timestamp", name: "Creado", id: "_startedAt" },
                            { type: "timestamp", name: "Cerrado", id: "closedAt" },
                            { type: "timestamp", name: "Subido", id: "_createdAt" },
                            { type: "member", name: "Usuario.Nombre", id: "firstName" },
                            { type: "member", name: "Usuario.Apellido", id: "lastName" },
                            { type: "member", name: "Usuario.Email", id: "email" },
                        ];

                        // Con este If Arma las columnas de validación del ultimo estado con venia funcionando Historicamente ante que Charly hiciera la suya
                        if (formSelected.validate_required) {
                            baseCols = baseCols.concat(camposValidacion(formSelected.validate_pages, null));
                       
                            console.log('formSelected.validate_instances', formSelected.validate_instances, "VALIDATE INSTANCES")
                            //Y aca deberia estar armando los campos por cada instancia de validacion siempre y cuando validate_instances sea mayor a 1, ya que sino no tiene sentido y deberia usarse el de arriba
                            if (formSelected.validate_instances > 1) {
                                for (let i = 0; i < formSelected.validate_instances; i++) {
                                    baseCols = baseCols.concat(camposValidacion(formSelected.validate_pages, i));
                                }
                            }
                        }
                    }

                    // Procesar elementos de form.pages (lógica original - withNodes se aplica AQUÍ)
                    let formElements = [];
                    if (formSelected && formSelected.pages) {
                        formElements = formSelected.pages.flatMap((page) => {
                            return page.fields.reduce((lst, ele) => {
                                ele.name = ele.name || ele.label;
                                if (typeElement == undefined || typeElement.includes(ele.type))
                                    lst.push(ele);
                                if (withNodes && ele.nodes)
                                    lst = lst.concat(
                                        ele.nodes.map((subele) => {
                                            subele.parentId = ele.id;
                                            subele.name = subele.name || subele.label;
                                            return subele;
                                        })
                                    );
                                return lst;
                            }, []);
                        });
                    }
                    //Aca aun no descubri si esta alucinando El o la AI que uso.
                    if (includeValidatePages && formSelected && formSelected.validate_pages) {
                        let validateElements = _this.processValidatePages(formSelected);
                        formElements = formElements.concat(validateElements);
                    }

                    return baseCols.concat(formElements);
                })
                .catch((e) => {
                    console.error('Error in getElementsForm:', e);
                    return [];
                });
        };

        _this.processValidatePages = function (form) {
            let validateBaseElements = []
            if (form?.validate_required) {
                validateBaseElements.push({ id: "validateState", name: "Validate_State", type: "text" });
                validateBaseElements.push({ id: "validateDate", name: "Validate_Date", type: "timestamp" });
                validateBaseElements.push({ id: "validateUser", name: "Validate_User", type: "text" });
                validateBaseElements.push({ id: "validate_lastUser", name: "Validate_LastUser", type: "text" });
            }

            // Aplana group/simplelist a cualquier profundidad (group > simplelist > campo, etc.)
            const flattenValidateNodes = (nodes, parentId) => {
                let result = [];
                (nodes || []).forEach((node) => {
                    if (!node) return;
                    const childNodes = Array.isArray(node.nodes)
                        ? node.nodes
                        : (node.nodes ? Object.values(node.nodes) : null);
                    const nodeId = "validate_".concat(node.id);

                    if (node.type === 'group' && childNodes) {
                        result.push({
                            ...node,
                            id: nodeId,
                            name: "Validate_".concat(node.name || node.label),
                            parentId: parentId
                        });
                        result = result.concat(flattenValidateNodes(childNodes, nodeId));
                    } else if (node.type === 'simplelist' && childNodes) {
                        // No se agrega el contenedor; los hijos llevan parentId del simplelist
                        result = result.concat(flattenValidateNodes(childNodes, nodeId));
                    } else if (node.name || node.label) {
                        result.push({
                            ...node,
                            id: nodeId,
                            name: "Validate_".concat(node.name || node.label),
                            parentId: parentId
                        });
                    }
                });
                return result;
            };
            
            let validateElements = (form.validate_pages || []).reduce(function (list, page) {
                return list.concat(flattenValidateNodes(page.fields));
            }, []);

            return validateBaseElements.concat(validateElements);
        };

        _this.getElementsIntegration = () => {
            let integration = _this.integrations.find(
                (integration) => integration.id == _this.datasource.integrationId
            );
            if (integration == undefined) return [];
            let lst = [];
            for (let key in integration.configuration.populateValues) {
                lst.push({ id: key, type: "text", name: key });
            }
            return lst;
        };

        _this.reloadDistinct = () => {
            _this.reloadElements();
            _this.getElementsForm2()
        }

        _this.reloadElements = function () {
            // console.log('reloadElements')
            _this.allElementsForm = [];
            _this.filteredElementsForm = [];

            if (_this.datasource.type == "action") {
                _this.loadActionFormFields();
                return;
            }

            if (["relation", "leftRelation", "concatenate"].includes(_this.datasource.type)) {
                return;
            }

            if (_this.datasource.type != "integration") {
                let formSelected = undefined;
                if (_this.datasource.type == "query") {
                    if (_this.datasource.formId && _this.datasource.formId != '') {
                        formSelected = _this.forms.find(function (form) {
                            return form.id == _this.datasource.formId;
                        });
                    }
                } else {
                    formSelected = this.forms.find(function (form) {
                        return form.id == _this.datasource.formId;
                    });
                }

                if (formSelected == undefined) return;
                if (_this.datasource.type != 'distinct') {
                    _this.itemsForm(formSelected);
                }
            }
            if (_this.datasource.type == "integration") {
                _this.allElementsForm = _this.getElementsIntegration();
            }
        };

        _this.toggleCheck = function (listElements, field) {
            listElements = listElements || {};
            if (listElements[field.id] == undefined) {
                listElements[field.id] = JSON.parse(JSON.stringify(field));
                if (listElements[field.id].nodes) listElements[field.id].nodes = {};
            } else {
                delete listElements[field.id];
                if (field.id === "locked") {
                    delete listElements.lockedBy;
                }
            }
        };

        _this.itemsForm = function (formSelected) {
            if (_this.datasource.type == "action") {
                return;
            }
            if (["relation", "leftRelation", "concatenate"].includes(_this.datasource.type)) {
                return;
            }
            if (_this.datasource.type == "query" &&
                ["workflow","ptw"].includes(formSelected.type) &&
                formSelected.workflow &&
                _this.datasource.moreFields["wkfuserNext"] == undefined) {
                let fx = "";
                if (formSelected.workflow.reject)
                    fx = fx.concat(formSelected.workflow.reject, "?", "'':");
                if (formSelected.workflow.steps.length > 0) {
                    fx = fx.concat(formSelected.workflow.steps[formSelected.workflow.steps.length - 1].checkStepON, "?", "'':");
                    for (let i = formSelected.workflow.steps.length - 2; i >= 0; i--) {
                        const step = formSelected.workflow.steps[i];
                        const step1 = formSelected.workflow.steps[i + 1];
                        fx = fx.concat(step.checkStepON, " ? ", step1.member.concat('.substr(', step1.member, '.indexOf("|")+1)'), " : ");
                    }
                    fx = fx.concat(formSelected.workflow.steps[0].member.concat('.substr(', formSelected.workflow.steps[0].member, '.indexOf("|")+1)'));
                }
                _this.datasource.moreFields["wkfuserNext"] = {
                    name: "Pendiente Usuario",
                    id: "wkfuserNext",
                    fx: fx,
                    type: "text",
                    graphColumn: true,
                };
                fx = "";
                if (formSelected.workflow.reject)
                    fx = fx.concat(formSelected.workflow.reject, "?", "'Rechazado':");
                for (const step of formSelected.workflow.steps.reverse()) {
                    fx = fx.concat(step.checkStepON, "?", "'", step.name, "':");
                }
                fx = fx.concat("'", formSelected.workflow.step0_name, "'");
                _this.datasource.moreFields["wkfstatus"] = {
                    name: "Estado",
                    id: "wkfstatus",
                    fx: fx,
                    type: "text",
                    graphColumn: true,
                };

                fx = 'new Date(_createdAt).toLocaleString();';
                _this.datasource.moreFields["wkflastDate"] = {
                    name: "Fecha Ultimo Estado",
                    id: "wkflastDate",
                    fx: fx,
                    type: "text",
                    graphColumn: true,
                };

                fx = '((date2)=>{let val=(((new Date()).getTime() - (new Date(date2).getTime()) )/ 3600000);val="".concat(parseInt(val),"hs ", parseInt((val-parseInt(val))*60),"min");return val;})(_createdAt)';
                _this.datasource.moreFields["wkftimeElapsed"] = {
                    name: "Horas Pendiente",
                    id: "wkftimeElapsed",
                    fx: fx,
                    type: "text",
                    graphColumn: true,
                };

                fx = "";
                for (const step of formSelected.workflow.steps.reverse()) {
                    fx = fx.concat(step.checkStepON, "?", step.member.concat('.substr(', step.member, '.indexOf("|")+1)'), ":");
                }
                if (formSelected.workflow.requestby)
                    fx = fx.concat(formSelected.workflow.requestby.concat('.substr(', formSelected.workflow.requestby, '.indexOf("|")+1)'));
                else
                    fx = fx.concat("'N/D'");
                _this.datasource.moreFields["wkfuser"] = {
                    name: "Responsable",
                    id: "wkfuser",
                    fx: fx,
                    type: "text",
                    graphColumn: true,
                };
            }
            _this.getElementsForm(undefined, false).then(els => _this.allElementsForm = [].concat(els));
            _this.getElementsForm(_this.elementsTypeToFilter, true).then(els => _this.filteredElementsForm = [].concat(els));

            // Limpia elements huérfanos. Hay que recorrer nodes: los validate anidados
            // (simplelist dentro de group) viven en nodes y no como ítems top-level.
            _this.getElementsForm(undefined, true).then(els => {
                if (!_this.datasource.elements) return;
                const validIds = new Set();
                const collectIds = (list) => {
                    (list || []).forEach((el) => {
                        if (!el || !el.id) return;
                        validIds.add(el.id);
                        if (el.nodes) {
                            collectIds(Array.isArray(el.nodes) ? el.nodes : Object.values(el.nodes));
                        }
                    });
                };
                collectIds(els);
                Object.keys(_this.datasource.elements).forEach((key) => {
                    if (!validIds.has(key)) {
                        delete _this.datasource.elements[key];
                    }
                });
            });
        }

        _this.canOpenFilters = () => {
            const ds = _this.datasource;
            if (!ds) return false;
            const hasValue = (v) => v !== undefined && v !== null && v !== "";
            if (ds.type === "action") {
                return hasValue(ds.formId) && hasValue(ds.actionId);
            }
            if (ds.type === "integration") {
                return hasValue(ds.integrationId);
            }
            if (ds.type === "distinct") {
                const optionsType = _this.element && _this.element.templateData && _this.element.templateData.optionsType;
                if (optionsType === "integration") return hasValue(ds.integrationId);
                if (optionsType === "dynamic") return hasValue(ds.formId);
                return false;
            }
            if (ds.type === "query") {
                return hasValue(ds.formId);
            }
            return false;
        };

        _this.openFilterConfig = function () {
            if (!_this.canOpenFilters()) return;
            var options = {
                animation: true,
                controller: require("./dataSourceFilterDirective"),
                templateUrl: "dashboard-graphBuilder/dataSourceFilterDirective.html",
                controllerAs: "ctrl",
                size: "lg",
                windowClass: "dialog",
                bindToController: true,
                resolve: {
                    datasource: function () {
                        _this.datasource.id = _this.element.id; // add id to datasource to filter element if needed
                        return _this.datasource;
                    },
                    form: function () {
                        if (_this.datasource.type === "action" || _this.datasource.type === "integration") return null;
                        const optionsType = _this.element && _this.element.templateData && _this.element.templateData.optionsType;
                        if (_this.datasource.type === "distinct" && optionsType === "integration") return null;
                        if (!_this.datasource.formId) return null;
                        return _this.forms.find(
                            (form) => form.id == _this.datasource.formId
                        ) || null;
                    },
                    integration: function () {
                        if (_this.datasource.type === "action" || _this.datasource.type === "query") return null;
                        const optionsType = _this.element && _this.element.templateData && _this.element.templateData.optionsType;
                        if (_this.datasource.type === "distinct" && optionsType !== "integration") return null;
                        if (_this.datasource.type !== "integration" && _this.datasource.type !== "distinct") return null;
                        if (!_this.datasource.integrationId) return null;
                        return _this.integrations.find(
                            (integration) => integration.id == _this.datasource.integrationId
                        ) || null;
                    },
                    actionFields: function () {
                        if (_this.datasource.type !== "action") return null;
                        return _this.getActionFilterFields();
                    }
                },
            };

            $uibModal.open(options)
            .result.then((result) => {
                delete _this.datasource.id; // delete id for filter objetc to return

            }, function() { //dismiss
                delete _this.datasource.id; // delete id for filter objetc to return
            });;
        };

        this.error = "";

        _this.validateFields = () => {
            _this.error = "";
            let errors = [];

            // errors.push(

            switch (_this.datasource.type) {
                case "query":
                    if (!_this.datasource.formId || _this.datasource.formId == '') {
                        // errors.push('Formulario');
                        errors.push($translate.instant("DASHBOARD.DASH_BUILDER.DATASOURCE.FORM_DESCRIPTION"));
                    }
                    break;
                case "action":
                    if (!_this.datasource.formId || _this.datasource.formId == '') {
                        errors.push($translate.instant("DASHBOARD.DASH_BUILDER.DATASOURCE.FORM_DESCRIPTION"));
                    }
                    if (!_this.getSelectedAction()) {
                        errors.push($translate.instant("DASHBOARD.DASH_BUILDER.DATASOURCE.ACTION_DESCRIPTION"));
                    }
                    break;
                case "integration":
                    if (!_this.datasource.integrationId || _this.datasource.integrationId == '') {
                        // errors.push('Integración');
                        errors.push($translate.instant("DASHBOARD.DASH_BUILDER.DATASOURCE.INTEGRATION_DESCRIPTION"));
                    }
                    break;
                case "concatenate":
                    if (!_this.element.templateData.datasource.otherDsIds || _this.element.templateData.datasource.otherDsIds.length == 0) {
                        // errors.push('Data sources a unir verticalmente');
                        errors.push($translate.instant("DASHBOARD.DASH_BUILDER.DATASOURCE.CONCATENATE_DESCRIPTION"));
                    }
                    break;
                case "relation":
                    if (!_this.datasource.leftDsId || _this.datasource.leftDsId == '') {
                        // errors.push('DS 1 - DataSource');
                        errors.push(`${$translate.instant("DASHBOARD.DASH_BUILDER.DATASOURCE.DS1")} - ${$translate.instant("DASHBOARD.DASH_BUILDER.DATASOURCE.DATASOURCE")}`);
                    }
                    if (!_this.datasource.leftDsKey || _this.datasource.leftDsKey == '') {
                        // errors.push('DS 1 - Campo DataSource');
                        errors.push(`${$translate.instant("DASHBOARD.DASH_BUILDER.DATASOURCE.DS1")} - ${$translate.instant("DASHBOARD.DASH_BUILDER.DATASOURCE.DATASOURCE_FIELD")}`);
                    }
                    if (!_this.datasource.rightDsId || _this.datasource.rightDsId == '') {
                        // errors.push('DS 2 - DataSource');
                        errors.push(`${$translate.instant("DASHBOARD.DASH_BUILDER.DATASOURCE.DS2")} - ${$translate.instant("DASHBOARD.DASH_BUILDER.DATASOURCE.DATASOURCE")}`);
                    }
                    if (!_this.datasource.rightDsKey || _this.datasource.rightDsKey == '') {
                        // errors.push('DS 2 - Campo DataSource');
                        errors.push(`${$translate.instant("DASHBOARD.DASH_BUILDER.DATASOURCE.DS2")} - ${$translate.instant("DASHBOARD.DASH_BUILDER.DATASOURCE.DATASOURCE_FIELD")}`);
                    }
                    break;
                case "leftRelation":
                    if (!_this.datasource.leftDsId || _this.datasource.leftDsId == '') {
                        // errors.push('DS 1 - DataSource');
                        errors.push(`${$translate.instant("DASHBOARD.DASH_BUILDER.DATASOURCE.DS1_PRIMARY")} - ${$translate.instant("DASHBOARD.DASH_BUILDER.DATASOURCE.DATASOURCE")}`);
                    }
                    if (!_this.datasource.leftDsKey || _this.datasource.leftDsKey == '') {
                        // errors.push('DS 1 - Campo DataSource');
                        errors.push(`${$translate.instant("DASHBOARD.DASH_BUILDER.DATASOURCE.DS1_PRIMARY")} - ${$translate.instant("DASHBOARD.DASH_BUILDER.DATASOURCE.DATASOURCE_FIELD")}`);
                    }
                    if (!_this.datasource.rightDsId || _this.datasource.rightDsId == '') {
                        // errors.push('DS 2 - DataSource');
                        errors.push(`${$translate.instant("DASHBOARD.DASH_BUILDER.DATASOURCE.DS2_SECONDARY")} - ${$translate.instant("DASHBOARD.DASH_BUILDER.DATASOURCE.DATASOURCE")}`);
                    }
                    if (!_this.datasource.rightDsKey || _this.datasource.rightDsKey == '') {
                        // errors.push('DS 2 - Campo DataSource');
                        errors.push(`${$translate.instant("DASHBOARD.DASH_BUILDER.DATASOURCE.DS2_SECONDARY")} - ${$translate.instant("DASHBOARD.DASH_BUILDER.DATASOURCE.DATASOURCE_FIELD")}`);
                    }
                    break;

                default:
                    break;
            }

            if (errors.length > 0) {
                _this.error =
                    $translate.instant(
                        "DASHBOARD.DASH_BUILDER.DATASOURCE.ERROR_DS_PRE"
                    ) +
                    "<br>" +
                    errors.join("<br>");
                return false;
            }

            _this.error = "";
            return true;
        }

        this.checkResult = function () {
            let validate = _this.validateFields();
            if (validate) {
                graphDataFactory.getData(_this.element.id, true)
                .then(function (data) {
                    // console.log('data', data)
                    _this.openOutPutConsole(data);
                });

            } else {
                // Error message.
                this.errorMessage(
                    // 'Titulo',
                    $translate.instant("DASHBOARD.DASH_BUILDER.DATASOURCE.ERROR_DS_TITLE"),
                    _this.error
                );
            }
        };

        this.errorMessage = function (title, error) {
            dialog.alert({
                title: title,
                body: $sce.trustAsHtml(error),
                close: $translate.instant("DASHBOARD.CLOSE"),
                size: "md",
                html: true,
            });
        };

        this.openOutPutConsole = function (message) {
            $uibModal.open({
                animation: true,
                template: `<div style="margin: 10px;padding: 10px;"><div class="row dashboard-section-title"><div class="col-sm-12"><h3 class="dashboard-section-title__h3">OUTPUT:</h3>
            <small>Salida de Datos segun parametros configurados para el elemento</small></div>
                    <div class="col-sm-12"><textarea style="padding:10px;background-color: #fcf6db;color:#000;border: 1px solid #e5e0c6;height: 500px;width:100%;">{{ctrl.responseText}}</textarea></div>
                    <div class="row margin-top">
                        <div class="col-sm-12">                                            
                        </div>
                    </div>
                </div>`,
                controller: [
                    "$uibModalInstance",
                    "responseText",
                    function ($uibModalInstance, responseText) {
                        this.responseText = JSON.stringify(responseText, undefined, 4);
                        this.close = function () {
                            $uibModalInstance.close();
                        };
                    },
                ],
                resolve: {
                    responseText: function () {
                        return message;
                    },
                },
                controllerAs: "ctrl",
                size: "lg",
                windowClass: "dialog",
                bindToController: true,
            });
        };

        this.getElements = function (container, type) {
            return [].concat(
                container.pages.flatMap((page) => {
                    return page.fields
                        .filter(
                            (ele) =>
                                ele.type === type && ele.name && ele.id != _this.element.id
                        )
                        .concat(
                            page.fields
                                .filter((ele) => ele.nodes != undefined)
                                .flatMap((group) =>
                                    group.nodes.filter(
                                        (node) =>
                                            node.type === type &&
                                            node.name &&
                                            node.id != _this.element.id
                                    )
                                )
                        );
                })
            );
        };

        this.getDataSourceFinishKeys = (dsId) => {
            let ds = _this.lstDataSources.find((ds) => ds.id == dsId);
            if (ds == undefined) return [];
            const datasource = ds.templateData && ds.templateData.datasource;
            if (!datasource) return [];
            let list = (Object.values(datasource.elements || {}).concat(Object.values(datasource.moreFields || {}))).flatMap(
                (e) => {
                    if (e && e.type == "simplelist" && e.subItemsCols == "expand") {
                        return Object.values(e.nodes || {});
                    }
                    return e;
                }
            );
            return list.filter(Boolean);
        };

        this.onRelationSourceChange = (side) => {
            _this.lstDataSources = _this.getElements(_this.graph, "datasource");
            if (side === "left") {
                _this.lstLeftKeys = _this.getDataSourceFinishKeys(_this.datasource.leftDsId);
            } else {
                _this.lstRightKeys = _this.getDataSourceFinishKeys(_this.datasource.rightDsId);
            }
            _this.refreshRelationElements();
        };

        this.concatMakeElementList = () => {
            const previous = _this.element.templateData.datasource.elements || {};
            const next = {};
            const selectedIds = _this.element.templateData.datasource.otherDsIds || [];
            const isDateCutType = (type) => type === 'date' || type === 'timestamp';
            const copyFieldConfig = (cloned, old) => {
                if (!old) {
                    if (!isDateCutType(cloned.type)) delete cloned.localeAndCutDate;
                    return cloned;
                }
                if (old.type) cloned.type = old.type;
                if (old.show !== undefined) cloned.show = old.show;
                if (old.linkHTML !== undefined) cloned.linkHTML = old.linkHTML;
                else delete cloned.linkHTML;
                if (old.templateData) cloned.templateData = old.templateData;
                if (old.id) cloned.id = old.id;
                if (old.name) cloned.name = old.name;
                if (isDateCutType(cloned.type) && old.localeAndCutDate !== undefined) {
                    cloned.localeAndCutDate = !!old.localeAndCutDate;
                } else {
                    delete cloned.localeAndCutDate;
                }
                return cloned;
            };
            (_this.lstDataSources || []).forEach((datasourceEl) => {
                if (!selectedIds.includes(datasourceEl.id)) return;
                const ds = datasourceEl.templateData && datasourceEl.templateData.datasource;
                if (!ds) return;
                const sources = Object.values(ds.elements || {}).concat(Object.values(ds.moreFields || {}));
                sources.forEach((element) => {
                    if (!element || !element.name) return;
                    const elementKey = sanitizeMongoKeys.toMongoSafeKey(element.name.toUpperCase());
                    if (next[elementKey] != undefined) return;
                    const cloned = JSON.parse(JSON.stringify(element));
                    next[elementKey] = copyFieldConfig(cloned, previous[elementKey]);
                });
            });
            _this.element.templateData.datasource.elements = next;
        };

        _this.addElementsIntegrationList = () => {
            let integration = _this.integrations.find(
                (integration) => integration.id == _this.datasource.integrationId
            );
            if (integration == undefined) return [];
            const previous = _this.element.templateData.datasource.elements;
            const prevByKey = {};
            (Array.isArray(previous) ? previous : Object.values(previous || {})).forEach((el) => {
                if (el && (el.id || el.name)) {
                    prevByKey[el.id || el.name] = el;
                }
            });
            let lst = [];
            for (let key in integration.configuration.populateValues) {
                const prev = prevByKey[key];
                if (prev) {
                    lst.push(prev);
                } else {
                    lst.push({
                        id: key,
                        type: "text",
                        name: key,
                        show: true,
                        templateData: { align: "left" }
                    });
                }
            }
            _this.allIntegrationElements = lst;
            _this.element.templateData.datasource.elements = lst;
        };

        // Arma campos resultantes del Link DS. Si el campo ya existía, preserva type/config;
        // solo infiere type/linkHTML la primera vez que aparece el campo.
        _this.buildRelationElementsList = () => {
            const existing = _this.element.templateData.datasource.elements || [];
            const existingByName = {};
            (Array.isArray(existing) ? existing : Object.values(existing)).forEach(el => {
                if (el && el.name) {
                    existingByName[el.name] = el;
                }
            });

            let lst = [];
            const addedNames = {};
            (_this.lstLeftKeys || []).concat((_this.lstRightKeys || [])).forEach(item => {
                if (!item || !item.name || addedNames[item.name]) {
                    return;
                }
                addedNames[item.name] = true;
                const prev = existingByName[item.name];
                if (prev) {
                    lst.push(prev);
                    return;
                }
                const isLinkReport = !!(item.linkHTML || item.type === 'linkReport');
                let newItem = {
                    id: item.name,
                    name: item.name,
                    type: isLinkReport ? 'linkReport' : (['number', 'date', 'timestamp'].includes(item.type) ? item.type : 'text'),
                    show: true,
                    templateData: { align: 'left' }
                };
                if (isLinkReport) {
                    newItem.linkHTML = true;
                }
                if (['date', 'timestamp'].includes(newItem.type) && item.localeAndCutDate) {
                    newItem.localeAndCutDate = true;
                }
                lst.push(newItem);
            });
            return lst;
        };

        _this.refreshRelationElements = () => {
            _this.element.templateData.datasource.elements = _this.buildRelationElementsList();
        };

        _this.getResultingFields = () => {
            const els = _this.datasource.elements;
            const list = Array.isArray(els) ? els : Object.keys(els || {}).map((key) => els[key]);
            return list.filter((el) => el && (el.name || el.id));
        };

        _this.addElementsRelationList = () => {
            _this.refreshRelationElements();
        };

        // Exact same as addElementsRelationList
        _this.addElementsLeftRelationList = () => {
            _this.refreshRelationElements();
        };

        // For distinc - Selection - dynamic
        _this.getElementsForm2 = () => {
            _this.getElementsForm(_this.elementsTypeToFilter, false, true).then(els => {
                if (els) {
                    _this.elementsOfForm = [].concat(els)
                } else {
                    _this.elementsOfForm = undefined;
                }
            });
        }

        $scope.$on('datasource:toggle', function(event, section) {
            _this.toggleDSSection(section);
        });
        
        _this.toggleDSSection = (section) => {
            const keyMap = {
                options: 'openOptions',
                fields: 'openFields',
                columns: 'openColumns',
                script: 'openScritpt',
                config: 'openConfig',
                all: 'openAll'
            };

            const key = keyMap[section];
            if (!key) return false;

            if (section === 'all') {
                const newValue = !_this.datasource.viewConfig.openAll;
                _this.datasource.viewConfig.openAll = newValue;
                _this.datasource.viewConfig.openOptions = newValue;
                _this.datasource.viewConfig.openFields = newValue;
                _this.datasource.viewConfig.openColumns = newValue;
                _this.datasource.viewConfig.openScritpt = newValue;
                _this.datasource.viewConfig.openConfig = newValue;
            } else {
                _this.datasource.viewConfig[key] = !_this.datasource.viewConfig[key];
                _this.datasource.viewConfig.openAll = false;
            }
        };

        _this.getElementsForm2();
        _this.reloadElements();
        if (_this.datasource.type === "action" && _this.datasource.formId) {
            _this.loadActionFormFields();
            _this.getFormActions().then(function (actions) {
                _this.formActions = actions;
                if (_this.getSelectedAction(actions)) {
                    _this.onActionSelected();
                }
            });
        }
        _this.lstDataSources = _this.getElements(_this.graph, "datasource");
        _this.lstLeftKeys = _this.getDataSourceFinishKeys(
            _this.datasource.leftDsId
        );
        _this.lstRightKeys = _this.getDataSourceFinishKeys(
            _this.datasource.rightDsId
        );
        if (_this.datasource.type === "relation" || _this.datasource.type === "leftRelation") {
            const els = _this.datasource.elements;
            const isEmpty = !els || (Array.isArray(els) ? els.length === 0 : Object.keys(els).length === 0);
            if (isEmpty) {
                _this.refreshRelationElements();
            }
        }
    },
];

module.exports = function () {
    return {
        restrict: "E",
        scope: {
            element: "=",
            graph: "=",
            forms: "=",
            integrations: "=",
            departmentforms: '='
        },
        replace: true,
        controller: dataSourceCtrl,
        controllerAs: "ctrl",
        bindToController: true,
        templateUrl: "dashboard-graphBuilder/dataSourceDirective.html",
    };
};
